/* @flow */
import React from 'react';
import cx from 'classnames';
import { getPropClassesFromInstance } from 'lib/getPropClasses';

import './styles/Row.scss';

export default class extends React.Component {
  static propTypes = {
    size: React.PropTypes.oneOf(['large', 'medium', 'small']),
  };

  static propClasses = {
    size: {
      large: 'Row--large',
      medium: 'Row--medium',
      small: 'Row--small',
    },
  };

  static defaultProps = {
    size: 'medium',
  };

  render() {
    return (
      <div className={cx('Row', getPropClassesFromInstance(this))}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Row.jsx